import TypedError from 'error/typed';

export default TypedError({
    type: 'Widgets.ui.TemplateNotFoundException',
    message: 'Can\'t retrieve template. Template selector : {text}',
    templateSelector: null,
});
